import { context as otContext, type Context } from "@opentelemetry/api";

let current: Context | null = null;

export function setOtelContext(ctx: Context | null): void {
  current = ctx;
}

export function getOtelContext(): Context {
  return current ?? otContext.active();
}
